/**
 * @generated SignedSource<<0492bd1e6bcda4de49b9c769e6717cbd>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "myScheduleModel"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v6 = {
        "kind": "Variable",
        "name": "model",
        "variableName": "myScheduleModel"
    }, v7 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        },
        (v6 /*: any*/)
    ], v8 = {
        "kind": "InlineFragment",
        "selections": [
            (v2 /*: any*/)
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "start",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v11 = [
        (v3 /*: any*/),
        (v2 /*: any*/)
    ], v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "end",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "AssetModalQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Asset",
                    "kind": "LinkedField",
                    "name": "asset",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AssetAddress"
                        },
                        (v3 /*: any*/),
                        (v4 /*: any*/),
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "Asset"
                        },
                        (v5 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "SchedulableAsset",
                            "kind": "LinkedField",
                            "name": "schedulableEntity",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "args": [
                                        (v6 /*: any*/)
                                    ],
                                    "kind": "FragmentSpread",
                                    "name": "MySchedulePaginationContentAsset_shifts"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "AssetModalQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Asset",
                    "kind": "LinkedField",
                    "name": "asset",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "street",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "city",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "postalCode",
                            "storageKey": null
                        },
                        (v3 /*: any*/),
                        (v4 /*: any*/),
                        (v5 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "SchedulableAsset",
                            "kind": "LinkedField",
                            "name": "schedulableEntity",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v7 /*: any*/),
                                    "concreteType": "ICanBeUsedToCalculateScheduleTimesUnionTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "scheduleItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ICanBeUsedToCalculateScheduleTimesUnionTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v8 /*: any*/),
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                (v9 /*: any*/),
                                                                (v2 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "assignedEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v10 /*: any*/),
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Asset",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "asset",
                                                                                    "plural": false,
                                                                                    "selections": (v11 /*: any*/),
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "SchedulableAsset",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "User",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "user",
                                                                                    "plural": false,
                                                                                    "selections": (v11 /*: any*/),
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "SchedulableUser",
                                                                            "abstractKey": null
                                                                        },
                                                                        (v8 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "AssignmentType",
                                                                    "kind": "LinkedField",
                                                                    "name": "assignmentType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "title",
                                                                            "storageKey": null
                                                                        },
                                                                        (v2 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Schedule",
                                                                    "kind": "LinkedField",
                                                                    "name": "schedule",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v5 /*: any*/),
                                                                        (v2 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v12 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ScheduleShiftConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "simultaneousScheduleShift",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "ScheduleShiftEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "ScheduleShift",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v2 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": null,
                                                                                            "kind": "LinkedField",
                                                                                            "name": "assignedEntity",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v10 /*: any*/),
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        (v2 /*: any*/),
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "Asset",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "asset",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                (v5 /*: any*/),
                                                                                                                (v3 /*: any*/),
                                                                                                                (v2 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "SchedulableAsset",
                                                                                                    "abstractKey": null
                                                                                                },
                                                                                                (v8 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "status",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Event",
                                                                    "kind": "LinkedField",
                                                                    "name": "event",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v2 /*: any*/),
                                                                        (v5 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "isWork",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "isAbsence",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "type": "ScheduleShift",
                                                            "abstractKey": null
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ScheduleShift",
                                                                    "kind": "LinkedField",
                                                                    "name": "scheduleShift",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v9 /*: any*/),
                                                                        (v2 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Event",
                                                                    "kind": "LinkedField",
                                                                    "name": "reasonEvent",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v5 /*: any*/),
                                                                        (v2 /*: any*/),
                                                                        (v3 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v9 /*: any*/),
                                                                (v12 /*: any*/)
                                                            ],
                                                            "type": "ScheduleShiftAssigneeReplacement",
                                                            "abstractKey": null
                                                        },
                                                        (v10 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "cursor",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "totalCount",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "endCursor",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v7 /*: any*/),
                                    "filters": [
                                        "model"
                                    ],
                                    "handle": "connection",
                                    "key": "MySchedulePaginationContentAsset_scheduleItems",
                                    "kind": "LinkedHandle",
                                    "name": "scheduleItems"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "c3269131fa9e47371279fd7f1e50020b",
            "id": null,
            "metadata": {},
            "name": "AssetModalQuery",
            "operationKind": "query",
            "text": "query AssetModalQuery(\n  $id: ID!\n  $myScheduleModel: GetRunningScheduleRequestInput!\n) {\n  asset(id: $id) {\n    id\n    ...AssetAddress\n    color\n    description\n    ...Asset\n    name\n    schedulableEntity {\n      id\n      ...MySchedulePaginationContentAsset_shifts_4ntzPf\n    }\n  }\n}\n\nfragment Asset on Asset {\n  name\n  color\n}\n\nfragment AssetAddress on Asset {\n  street\n  city\n  postalCode\n}\n\nfragment MySchedulePaginationContentAsset_shifts_4ntzPf on SchedulableAsset {\n  scheduleItems(model: $myScheduleModel, first: 20) {\n    edges {\n      node {\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n        ... on ScheduleShift {\n          start\n        }\n        ... on ScheduleShiftAssigneeReplacement {\n          scheduleShift {\n            start\n            id\n          }\n        }\n        __typename\n        ...ScheduleShiftCard_scheduleShift\n        ...ScheduleShiftAbsenceCard_scheduleShiftAssigneeReplacement\n      }\n      cursor\n    }\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment ScheduleShiftAbsenceCard_scheduleShiftAssigneeReplacement on ScheduleShiftAssigneeReplacement {\n  reasonEvent {\n    name\n    id\n    color\n  }\n  start\n  end\n  scheduleShift {\n    id\n  }\n}\n\nfragment ScheduleShiftCard_scheduleShift on ScheduleShift {\n  id\n  assignedEntity {\n    __typename\n    ... on SchedulableAsset {\n      asset {\n        color\n        id\n      }\n    }\n    ... on SchedulableUser {\n      user {\n        color\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  assignmentType {\n    title\n    id\n  }\n  schedule {\n    name\n    id\n  }\n  end\n  simultaneousScheduleShift {\n    edges {\n      node {\n        id\n        assignedEntity {\n          __typename\n          ... on SchedulableAsset {\n            id\n            asset {\n              name\n              color\n              id\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n  }\n  start\n  status\n  event {\n    id\n    name\n    isWork\n    isAbsence\n  }\n}\n"
        }
    };
})();
node.hash = "42953f61c7cd7549f2e6c15dcb604609";
export default node;
